import http from '../../services/httpService';

export const v4getUserSubscriptions =  async (userId)  => await http.get(`v4/get_user_subscriptions/?email=${userId}`);
export const v4postUserSubscription =  async (payload) => await http.post('v4/subscribe/', payload);
export const putClearUuid =  async (payload) => await http.put('clear_uuid/', payload);
export const getCommHistory = async (email) => await http.get(`v1/get_comm_history/?email=${email}`);
export const getAllUserSubscriptions = async (email) => await http.get(`v1/all_user_subscriptions/?email=${email}`);
